const comm={
	//格式化手机号码
		iphonFormat: function(num) {
			return num.length === 11 ? num.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2') : num;
		},
		// 时间戳转换时间
		timeConvert:function(timestamp, num) {
			//num:0 YYYY-MM-DD  num:1  YYYY-MM-DD hh:mm:ss // timestamp:时间戳
			timestamp = timestamp + '';
			timestamp = timestamp.length == 10 ? timestamp * 1000 : timestamp;
			var date = new Date(timestamp);
			var y = date.getFullYear();
			var m = date.getMonth() + 1;
			m = m < 10 ? ('0' + m) : m;
			var d = date.getDate();
			d = d < 10 ? ('0' + d) : d;
			var h = date.getHours();
			h = h < 10 ? ('0' + h) : h;
			var minute = date.getMinutes();
			var second = date.getSeconds();
			minute = minute < 10 ? ('0' + minute) : minute;
			second = second < 10 ? ('0' + second) : second;
			if (num == 0) {
				return m + '-' + d + ' ' + h + ':' + minute;
			}else if(num == 1){
				return y + '-' + m + '-' + d
			}else if(num == 2){
				return y
			}else {
				return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
			}
		},
		trim: function(value) {
				return value.replace(/(^\s*)|(\s*$)/g, "");
			},
		// 单数组分割为
	     group:function(array, subGroupLength) {
			      let index = 0;
			      let newArray = [];
			      while(index < array.length) {
			          newArray.push(array.slice(index, index += subGroupLength));
			      }
			      return newArray;
		},
		/**
		 * 将数字取整为10的倍数
		 * @param {Number} num 需要取整的值
		 * @param {Boolean} ceil 是否向上取整
		 * @param {Number} prec 需要用0占位的数量
		 */
		formatInt:function(num, prec = 2, ceil = true) {
		  const len = String(num).length;
		  if (len <= prec) { return num }; 
		
		  const mult = Math.pow(10, prec);
		  return ceil ? 
		    Math.ceil(num / mult) * mult : 
		    Math.floor(num / mult) * mult;
		},
		//计算出现次数 
		Occurrences:function(arr, val){
			if(arr.length==0){
				return false
			}
			return arr.reduce((a, v) => (v == val ? a + 1 : a), 0)
		},
		//Array.some() 找到数组内是否有指定
		someobj:function(moods,val){
			return moods.some(mood => mood == val)
		},
		//数字转换
		numtocnnum:function(section) {
			var chnNumChar = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
			var chnUnitSection = ["", "万", "亿", "万亿", "亿亿"];
			var chnUnitChar = ["", "十", "百", "千"];
			var strIns = '',
				chnStr = '';
			var unitPos = 0;
			var zero = true;
			while (section > 0) {
				var v = section % 10;
				if (v === 0) {
					if (!zero) {
						zero = true;
						chnStr = chnNumChar[v] + chnStr;
					}
				} else {
					zero = false;
					strIns = chnNumChar[v];
					strIns += chnUnitChar[unitPos];
					chnStr = strIns + chnStr;
				}
				unitPos++;
				section = Math.floor(section / 10);
			}
			return chnStr;
		},
		//一维数组变二维数组
		listToMatrix:function(list, elementsPerSubArray) {
			var matrix = [],
				i, k;
		
			for (i = 0, k = -1; i < list.length; i++) {
				if (i % elementsPerSubArray === 0) {
					k++;
					matrix[k] = [];
				}
		
				matrix[k].push(list[i]);
			}
		
			return matrix;
		}
}
export default comm


// WEBPACK FOOTER //
// ./src/common/comme.js